import { TransformBoolean } from '../../../decorators/transform-boolean.decorator';
import { TransformFloat } from '../../../decorators/transform-float.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { DurationUnitEnum } from '../../../enums/duration-unit.enum';
import { PricingTierItemTypeEnum } from '../enums/pricing-tier-item-type.enum';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Pricing tier item DTO
 */
export class PricingTierItemDto {
  @TransformInt()
  id?: number;
  uuid!: string;
  type!: PricingTierItemTypeEnum;
  description?: string | null;
  durationUnit!: DurationUnitEnum;
  @TransformFloat()
  duration!: number;
  @TransformFloat()
  price!: number;
  @TransformBoolean()
  isStandardDiscountApplied?: boolean;
}
